import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Repeat, RefreshCw, Loader2, Mail, UserCheck } from 'lucide-react';
import { SearchBar, matchesSearch, formatDate } from './shared';

export default function RotatorTab({ authHeaders, API_URL, searchTerm, setSearchTerm }) {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLeads = async () => {
    setLoading(true);
    try {
      const resp = await axios.get(`${API_URL}/api/community/rotator/logs`, { headers: authHeaders });
      setLeads(resp.data.leads || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { fetchLeads(); }, []);

  const filtered = leads.filter(l => matchesSearch(l, searchTerm, ['email', 'message', 'assigned_to_name', 'assigned_to_email']));

  return (
    <div className="tab-content" data-testid="rotator-content">
      <div className="rotator-log-toolbar">
        <SearchBar value={searchTerm} onChange={setSearchTerm} placeholder="Anfragen durchsuchen..." />
        <button className="btn-icon" onClick={fetchLeads} title="Aktualisieren" data-testid="rotator-refresh">
          <RefreshCw size={16} />
        </button>
      </div>

      {loading ? (
        <div className="loading-state"><Loader2 size={28} className="spin" /><p>Lade Rotator-Anfragen...</p></div>
      ) : filtered.length === 0 ? (
        <div className="empty-state"><Repeat size={32} /><p>{searchTerm ? 'Keine Treffer.' : 'Noch keine Förderer-Anfragen über den Rotator.'}</p></div>
      ) : (
        <div className="rotator-log-list">
          {filtered.map(lead => (
            <div key={lead.id} className="rotator-log-card" data-testid={`rotator-lead-${lead.id}`}>
              <div className="rotator-log-head">
                <span className="rotator-log-email" data-testid="rotator-lead-email">
                  <Mail size={14} /> {lead.email}
                </span>
                <span className="rotator-log-date">{formatDate(lead.created_at)}</span>
              </div>
              {lead.interests && lead.interests.length > 0 && (
                <div className="rotator-log-interests">
                  {lead.interests.map((i, idx) => <span key={idx} className="rotator-log-badge">{i}</span>)}
                </div>
              )}
              {lead.message && <p className="rotator-log-message">{lead.message}</p>}
              <div className="rotator-log-assigned" data-testid="rotator-lead-assigned">
                <UserCheck size={14} />
                <span>Zugewiesen an: <strong>{lead.assigned_to_name}</strong> ({lead.assigned_to_email})</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
